import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { createInitialState, createPluginState, getPluginState } from './ai-audit-log-plugin-factory';
import { aiAuditLogsPluginKey } from './ai-audit-log-plugin-key';
import { sendAuditLogEvent, updateAIAuditLogPluginState } from './commands';
import { auditLogEvents } from './types';
export var createAIAuditLogPlugin = function createAIAuditLogPlugin(options) {
  var dispatch = options.dispatch,
    eventData = options.eventData;
  return new SafePlugin({
    key: aiAuditLogsPluginKey,
    state: createPluginState(dispatch, createInitialState(eventData)),
    view: function view(_view) {
      return {
        update: function update(view) {
          var pluginState = getPluginState(view.state);
          auditLogEvents.forEach(function (event) {
            var eventState = pluginState[event];
            if (eventState.eventStatus === 'send-event') {
              updateAIAuditLogPluginState(_defineProperty({}, event, {
                eventStatus: 'event-in-progress'
              }))(view.state, view.dispatch);
              sendAuditLogEvent(event, view);
            }
          });
        }
      };
    }
  });
};